import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import styles from "./FieldError.module.scss";
import { ErrorIcon, NoticeTriangleIcon } from "../../../icons/monochrome";
import { Span, Popover } from "./../../";

const FieldError = React.memo(({ message, type = "error", className, style }) => {
    const ref = useRef();
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        setIsOverflow(false);
        setTimeout(() => {
            if(ref.current && ref.current.isConnected) {
                const spanNode = ref.current.childNodes[1];
                setIsOverflow(spanNode.scrollWidth > spanNode.clientWidth)
            }
        })
    }, [message]);

    return <div className={classNames(styles.base, className)} style={style} ref={ref}>
        {type === "warning" ? <NoticeTriangleIcon color="warning"/> : <ErrorIcon color="error"/>}
        <Span level={13} ellipsis><strong>{type === "warning" ? "Warning: " : "Error: "}</strong>{message}</Span>
        {isOverflow && <Popover placement="center" verticalPlacement="bottom" triggerClassName={styles["popover-trigger"]}>{message}</Popover>}
    </div>
});

export default FieldError;